import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/admission-heldesk-banner.webp";
import campusImage from "../../Images/student-services/admission-helpdek.webp";
import helpDesk from "../../Images/admision/help-desk.webp";
const AdmissionHelpdesk = () => {
  const helpList = [
    {
      icon: "📚",
      title: "Explore Courses",
      description: "Browse through our Programmes to find your ideal course.",
    },
    {
      icon: "✅",
      title: "Check Eligibility",
      description: "Make sure you meet the required academic criteria.",
    },
    {
      icon: "📝",
      title: "Fill Application Form",
      description: "Apply online or request a physical application form.",
    },
    {
      icon: "📄",
      title: "Submit Documents",
      description:
        "Upload or send the necessary academic and identity documents.",
    },
    {
      icon: "📩",
      title: "Get Admission Confirmation",
      description:
        "Once approved, receive your offer letter and complete fee payment.",
    },
    {
      icon: "🎓",
      title: "Begin Your Journey",
      description: "Start your academic journey at ISBM University!",
    },
  ];

  return (
    <React.Fragment>
      <title>Admission Help Desk – ISBM University | Get Support Now</title>
      <meta
        name="description"
        content="Need help with admissions? ISBM University’s Admission Help Desk offers guidance on applications, fees, and eligibility for a smooth process."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Admission Helpdesk</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Admission Helpdesk
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <h2 className="modern-title section-title text-blue text-center mb-4">
            Your First Step Toward a Bright Future
          </h2>
          <p className="text-center">
            Welcome to the ISBM University Admission Helpdesk – your one-stop
            destination for all queries and support related to the admission
            process. Whether you’re a prospective student, a parent, or a
            working professional looking to advance your career, our dedicated
            team is here to guide you through every stage of your admission
            journey.
          </p>
          <div className="bg-light p-4 rounded-3 mt-5 border-start border-4 border-purple">
            <h3 className="fs-2 fw-bold text-purple text-decoration-underline mb-4">
              Why Choose ISBM University?
            </h3>
            <p className="mb-2">
              <b>
                ISBM University is committed to empowering students through
                quality education, industry-oriented programs, and global
                academic standards. With a wide range of undergraduate,
                postgraduate, diploma, and doctoral programs, we ensure that you
                find the perfect course aligned with your goals.
              </b>
            </p>
          </div>
        </div>
      </section>

      <section className="pb-50">
        <div className="container-xxl">
          <Row className="align-items-center">
            <div className="col-md-6 col-12 mb-3 pe-lg-5">
              <div className="discipline-image shadow-lg rounded overflow-hidden">
                <img src={helpDesk} alt="Group 1" className="img-fluid" />
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="discipline-content">
                <h2 className="modern-title section-title-start text-blue">
                  What We Assist With
                </h2>
                <p className="lead">
                  Our Admission Helpdesk is equipped to provide personalized
                  support and guidance for:
                </p>
                <ul className="list-unstyled">
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Course selection based on your qualification and interest
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Understanding eligibility criteria and program structures
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Application procedures and documentation guidance
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Entrance exam or merit-based admission details (if
                    applicable)
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Fee structure and payment options
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Scholarship and financial aid information
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Important dates, deadlines, and admission updates
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Counselling support for career and academic planning
                  </li>
                </ul>
              </div>
            </div>
          </Row>
        </div>
      </section>

      <section className="ptb-50 bg-blue">
        <div className="container-xxl">
          <h2 className="text-center modern-title section-title text-white mb-5">
            How to Apply
          </h2>
          <div className="row m-0">
            {helpList.map((item, index) => (
              <div className="col-md-6 col-lg-4 mb-4" key={index}>
                <div className="d-flex h-100 border-end border-sm-0 pe-3">
                  <div className="me-3 fs-1 text-secondary">{item.icon}</div>
                  <div>
                    <h5 className="text-golden fw-bold mb-2">{item.title}</h5>
                    <p className="text-white small mb-0">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="helpdesk-content ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-blue text-center">
            Connect with Our Team
          </h2>
          <p className="text-blue text-center mb-5">
            Please do feel free to contact us through any of the following
            means:
          </p>

          <Row className="g-4">
            {/* Helpline Card */}
            <Col md={6} lg={6}>
              <div className="feature-card p-4 bg-white rounded shadow-sm mb-4">
                <div className="feature-icon mb-3 text-blue">
                  <i className="ti ti-phone-call feature-icon-style"></i>
                </div>
                <h4 className="mb-2 mt-4 text-purple fw-semibold">Helpline</h4>
                <div className="contact-detail">
                  <p className="fw-bold">+91-9373199999</p>
                  <p className="fw-bold">+91-9109244444</p>
                </div>
                <div className="contact-timing">
                  Available from Monday to Saturday,
                  <br />
                  between 10:00 AM and 6:30 PM
                </div>
              </div>
              <div className="feature-card p-4 bg-white rounded shadow-sm">
                <div className="feature-icon mb-3 text-blue">
                  <i className="ti ti-mail feature-icon-style"></i>
                </div>
                <h4 className="mb-2 mt-4 text-purple fw-semibold">Email Us</h4>
                <div className="contact-detail">
                  <a
                    href="mailto:enquiry@isbmuniversity.edu.in"
                    className="text-decoration-none text-blue"
                  >
                    <strong>enquiry@isbmuniversity.edu.in</strong>
                  </a>
                </div>
              </div>
            </Col>

            {/* Visit Card */}
            <Col md={6} lg={6}>
              <div className="feature-card h-100 p-4 bg-white rounded shadow-sm">
                <div className="feature-icon mb-3 text-blue">
                  <i className="ti ti-map-pin feature-icon-style"></i>
                </div>
                <h4 className="mb-2 mt-4 text-purple fw-semibold"> Visit Us</h4>

                <div className="contact-detail">
                  <strong className="text-blue">ISBM University Campus</strong>
                  <br />
                  Village-Nawapara (Kosmi) Block,
                  <br />
                  Tehsil-Chhura, District: Gariyaband,
                  <br />
                  Chhattisgarh
                  <br />
                  <strong className="text-blue">Pin:</strong> 493996
                </div>
                <div className="contact-detail mt-4">
                  <strong className="text-blue">
                    ISBM University Raipur Campus
                  </strong>
                  <br />
                  ISBM University, Ring Road No. 1,
                  <br />
                  Near Sarona Bridge, Tatibandh,
                  <br />
                  Raipur, Chhattisgarh
                  <br />
                  <strong className="text-blue">Pin:</strong> 492099
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default AdmissionHelpdesk;
